<template>
  <div class="bell" @click="clickOnBell">
    <font-awesome-layers full-width>
      <font-awesome-icon icon="bell" :class="'fa-xl ' + colorOfBell "/>
      <font-awesome-layers-text
          v-if="numberOfUnseenNotification"
          :value="numberOfUnseenNotification"
          transform="down-3 left-2 shrink-5"
          class="fa-layers-top-left fa-layers-counter"
          style="margin-left: 2px;"/>
    </font-awesome-layers>
  </div>
</template>

<script>
import EventBus from "@/utils/EventBus";
import Events from "@/utils/Events";
import ActivityManager from "@/activity/ActivityManager";
const UserNotificationsPanel = () => require("@/components/notifications/UserNotificationsPanel");
import NotificationDetails from "@/components/notifications/NotificationDetails";
import {getThemeColor} from "@/styles/ColorSet";
import {FontAwesomeLayersText, FontAwesomeLayers} from "@fortawesome/vue-fontawesome";


export default {
  name: "Bell",
  components: {FontAwesomeLayers, FontAwesomeLayersText},

  async beforeMount() {
    await this.loadUnseenNotifications();
    await this.countUnseenMessages();
  },

  async mounted() {
    this.$onEvent(ServerEvents.newNotification, this.reloadNotifications);
    this.$onEvent(Events.notificationsChanged, this.reloadNotifications);
  },

  methods: {

    waitForAnimations() {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve();
        }, 500);
      });
    },

    async showUserNotifications() {
      await ActivityManager.showActivity(UserNotificationsPanel);
      await this.closeMenuWindow();
    },

    async showDetailsNotification(id) {
      await ActivityManager.showActivity(NotificationDetails, {notificationId: id});
    },

    async reloadNotifications() {
      await this.countUnseenMessages();
      await this.loadUnseenNotifications();
    },

    async closeMenuWindow() {
      this.$emit('hide-bell');
      if (this.listOfTheLatestNotifications.length > 0) {
        await Rpc.Notifications.markAsSeen(this.listOfTheLatestNotifications[0].id);
        EventBus.$emit(Events.notificationsChanged);
      }
    },

    async clickOnBell() {
      let callback = (e) => {
        if (!document.getElementsByClassName('bell')[1] || !document.getElementsByClassName('bell')[1].contains(e.target)) {
          this.$emit('hide-bell');
          window.removeEventListener('click', callback);
        }
      }
      if (this.userMenuVisible || this.stickyNoteMenuVisible) {
        if (this.userMenuVisible) {
          this.$emit('hide-user-menu');
        } else {
          this.$emit('hide-sticky-note-menu');
        }
        await this.waitForAnimations();
        this.$emit('show-bell');
        setTimeout(() => window.addEventListener('click', callback));
        return;
      }

      if (!this.bellMenuVisible) {
        this.$emit('show-bell');
        setTimeout(() => window.addEventListener('click', callback));
      } else
        await this.closeMenuWindow();
    },

    async loadUnseenNotifications() {
      this.listOfTheLatestNotifications = await Rpc.Notifications.getLastUnseen(this.numberOfNotificationsOnBell);
    },

    setColors() {
      if (this.numberOfUnseenNotification !== 0)
        this.colorOfBell = this.yellow;
      else
        this.colorOfBell = this.blue;
    },

    async countUnseenMessages() {
      this.numberOfUnseenNotification = await Rpc.Notifications.countUnseen();
      this.setColors();
    },

  },

  props: {
    bellMenuVisible: {type: Boolean, default: false},
    userMenuVisible: {type: Boolean, default: false},
    stickyNoteMenuVisible: {type: Boolean, default: false},
  },

  data: () => ({
    listOfTheLatestNotifications: [],
    numberOfNotificationsOnBell: 5,
    blue: "",
    yellow: "text-warning",
    colorOfBell: "",
    numberOfUnseenNotification: 0,
    callback: null,
  }),

}
</script>

